import { sendHttp } from '../assets/js/request'

const hospitalManageApi = {
  // 获取医院和根节点
  getDeptList (prams) {
    return sendHttp('get', '/system/dept/list', prams)
  },
  // 获取医院员工账号
  getUserList (prams) {
    return sendHttp('get', '/system/user/getUser', prams)
  },
  // 重置密码
  resetPwd (prams) {
    return sendHttp('post', '/system/user/resetPwd/userId', prams)
  },
  // 根绝id获取员工详细信息
  getUserById (prams) {
    return sendHttp('get', '/system/user/getUserById', prams)
  },
  // 新增用户
  addUser (prams) {
    return sendHttp('post', '/system/user/add', prams)
  },
  // 编辑用户
  editUser (prams) {
    return sendHttp('post', '/system/user/edit', prams)
  },
  // 删除用户
  deleteUser (prams) {
    return sendHttp('delete', `/system/user/changeStatus/${prams}`)
  },
  // 添加机构
  addCompany (prams) {
    return sendHttp('post', '/system/dept/addCompany', prams)
  },
  // 添加部门
  addDept (prams) {
    return sendHttp('post', '/system/dept/addDept', prams)
  },
  // 编辑机构
  editDept (prams) {
    return sendHttp('post', '/system/dept/edit', prams)
  },
  // 查询所有部门
  getAllDept (prams) {
    return sendHttp('get', '/system/dept/all', prams)
  }
}

export {hospitalManageApi}



// WEBPACK FOOTER //
// ./src/apis/hospitalManageApi.js